import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  Panel,
  Message,
  Grid,
  Row,
  Col,
  Input,
  Slider,
  SelectPicker,
  ControlLabel,
  Button,
} from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import './styles.less'
import CKEditorBlankFrom from '../../components/forms/input/CKEditorBlankFrom'
import InputForm from '../../components/forms/input/InputForm'
import { isRequired } from '../../utils/ValidatorUtils'
import classNames from 'classnames'
import { cloneDeep } from 'lodash-es'
import {
  getProgressReportSubprojectClose,
  saveProgressReportSubprojectClose,
} from '../../redux/actions/progressReportSubproject'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { useDispatch } from 'react-redux'
import { getSchemaSubProjectDep6Sidebar } from '../../redux/actions/sidebar'

export default function IntroductionSubprojectClose({
  schema: _schema,
  period,
  projectCode,
  projectVersionId,
  installmentPlanId,
  progressReportsId,
  setProgressReportsId = () => {},
  isReadOnly,
  disabled,
  ...props
}) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [periodVal, setPeriodVal] = useState(period)
  const [projectCodeVal, setProjectCodeVal] = useState(projectCode)
  const [projectVersionIdVal, setProjectVersionIdVal] = useState(projectVersionId)
  const projectId = sessionStorage.getItem('projectId')
  const dispatch = useDispatch()

  useEffect(() => {
    setFormSchema(_schema)
  }, [_schema])

  const onSubmit = (data) => {
    let request = {
      projectVersionId: projectVersionIdVal || '',
      projectCode: projectCodeVal || '',
      progressReportsId: progressReportsId || '',
      period: periodVal,
      installmentPlanDetailId: installmentPlanId || '',
      introduction: data.introductionInput || '',
    }
    handleCallService(request)
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()

    try {
      const response = await saveProgressReportSubprojectClose(request)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setProgressReportsId(response.progressReportsId)
        handleGetSchema()
        await dispatch(getSchemaSubProjectDep6Sidebar(projectId))
      } else {
        setErrorMsg({ type: 'error', description: response.errorMessage })
      }
    } catch (error) {
      console.error('try catch error ', error)
      setIsError(true)
    }

    setIsLoading(false)
    doneLoading()
  }

  const handleGetSchema = async () => {
    startLoading()
    try {
      const response = await getProgressReportSubprojectClose(
        period,
        projectCode,
        projectVersionId,
        installmentPlanId
      )

      if (response) {
        setFormSchema(response.forms.introduction)
      }
    } catch (e) {
      console.log(' error', e)
    }
    doneLoading()
  }

  return (
    <>
      <Panel shaded header={formSchema.header} collapsible defaultExpanded>
        <Row>
          {!disabled ? (
            <Col lg={24} md={24} sm={24} xs={24}>
              <InputForm
                schema={formSchema.introductionInput}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                hideLabel={true}
                componentClass="textarea"
                rows={10}
              />
            </Col>
          ) : (
            <Col lg={24} md={24} sm={24} xs={24}>
              <p>{`${formSchema?.introductionInput?.value || ''}`}</p>
            </Col>
          )}
        </Row>
        <Row style={{ marginTop: 20 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <div style={{ paddingLeft: 40, paddingRight: 25 }}>
              {!disabled && (
                <SaveButton disabled={isLoading} onClick={handleSubmit(onSubmit)}>
                  บันทึก
                </SaveButton>
              )}
            </div>
          </Col>
        </Row>
      </Panel>
    </>
  )
}
